<template>
  <!-- start navigator -->
  <div class="container ps-lg-5 pe-lg-5 mt-1">
    <div class="row">
      <div class="
          col-12
          d-none d-lg-flex
          justify-content-between
          align-items-center
        ">
        <nav style="--bs-breadcrumb-divider: '>'" aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link class="text-decoration-none router-link" to="/AgenteService">หน้าแรก</router-link>
            </li>
            <li class="breadcrumb-item" aria-current="page">
              <router-link class="text-decoration-none router-link" to="/AgenteService">ข้อมูลยื่นคำร้อง</router-link>
            </li>
            <li class="breadcrumb-item router-link active">เปลี่ยนแปลงอีเมล</li>
          </ol>
        </nav>
      </div>
    </div>
  </div>
  <!-- end navigator -->
  <div class="container-lg">
    <div class="row">
      <!-- Left Menu -->
      <div class="col-left-menu">
        <div class="left-menu">
          <ul class="d-none d-lg-block">
            <Menu />
          </ul>
        </div>
      </div>
      <!-- Left Menu -->
      <!-- Mobile -->
      <div class="
          col-left-menu
          d-flex d-lg-none
          border-bottom
          align-items-center
          border-bottom
          w-100
          pl-3
          pr-3
        " style="background-color: #f2f2f2">
        <div class="icon-back">
          <router-link to="/AgenteService">
            <img src="@/assets/images/arrow-blue.svg" class="w-100" />
          </router-link>
        </div>
        <div class="title ps-md-3 ps-lg-3 d-block d-lg-none text-center w-100"
          style="font-family: DB Heavent; color: #0057a8">
          เปลี่ยนแปลงอีเมล
        </div>
      </div>
      <!-- Mobile -->
      <div class="col">
        <div class="title d-none d-lg-block border-bottom" style="font-family: DB Heavent; color: #0057a8">
          เปลี่ยนแปลงอีเมล
        </div>
        <div class="pb-3 pb-lg-3">
          <div class="mt-4 mt-lg-2">
            <div class="gray-3 fs-5 d-lg-inline-block mt-lg-2 font-family">
              อีเมลเดิม
            </div>
          </div>
          <div class="d-lg-flex align-items-center">
            <div class="blue-1 mt-1 mt-lg-1" style="font-family: monospace; font-size: 14px;">
              {{ this.$store.state.Email }}
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-md-6 col-lg-6">
            <div class="form-group fs-5">
              <label class="field a-field page__field font-family">
                เปลี่ยนเป็น<span class="required">*</span>
                <input v-model="Email" type="text" class="field__input a-field__input fs-6"
                  style="font-family: monospace;" autocomplete="off" />
              </label>
              <span class="text-danger" style="display: inline-block"></span>
            </div>
          </div>
        </div>
        <div class="row mb-3 mt-2">
          <div class="col-6 col-lg-6">
            <button type="button" class="btn btn-light btn-cancel font-family d-inline-block" data-bs-toggle="modal"
              data-bs-target="#exampleModal">
              ยกเลิก
            </button>
          </div>
          <div class="col-6 col-lg-6 text-right">
            <button type="button" class="btn btn-continue font-family d-inline-block" @click="EnterNext()">
              ขอรหัส OTP
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal -->
  <div class="modal fade font-family" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel"
    aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title fs-4" id="exampleModalLabel"></h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="icon-model">
            <img src="@/assets/images/icon-warning.svg" class="w-100" />
          </div>
          <div class="massege fw-normal text-center">
            <p class="mb-0">รายการเปลี่ยนแปลงของท่านยังไม่ได้รับ</p>
            <p class="mb-0">การบันทึก และข้อมูลที่ท่านกรอกจะถูกล้าง</p>
            <p class="mb-0 pt-lg-4">
              ท่านต้องการจะย้อนกลับไปก่อนหน้านี้ใช่หรือไม่
            </p>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-light fw-normal popup_cancel " data-bs-dismiss="modal">
            ไม่ต้องการ
          </button>
          <router-link to="/AgenteService">
            <button type="button" class="btn btn-model fw-normal" data-bs-dismiss="modal"
              @click="ClearData()">ต้องการ</button>
          </router-link>
        </div>
      </div>
    </div>
  </div>

  <div v-if="this.Loading">
    <LoadingBs5></LoadingBs5>
  </div>
</template>

<script>
import Menu from "@/components/agenteservice/Menu.vue";

import LoadingBs5 from "@/components/frontend/LoadingBs5";
import http from "@/services/AuthService";
import Swal from 'sweetalert2/src/sweetalert2.js'

export default {
  name: "EditEmail",
  components: {
    Menu,
    LoadingBs5
  },
  data() {
    return {
      Email: this.$store.state.EditAgentInfo.CHANGE_EMAIL.EMAIL,
      Loading: false,
    };
  },
  mounted() {
    if (this.$store.state.AgentCode == '') {
      this.$router.push('/');
    }
  },
  methods: {
    EnterNext() {
      if (this.Email !== '') {
        this.Loading = true;
        let result = this.ValidateEmail(this.Email);
        if (result === false) {
          Swal.fire({
            icon: 'error',
            html: '<lable class="fs-4 fw-normal font-family">ฟอร์มอีเมลไม่ถูกต้อง กรุณากรอกใหม่</lable>',
            confirmButtonText: 'รับทราบ'
          }).then(() => {
            this.Email = '';
          });

          this.Loading = false;
        }
        else {
          let AuthorizeToken = localStorage.getItem("AuthorizeToken");
          this.Loading = true;
          const requestBody = {
            email: this.Email
          }
          http.post("AgencyERequest/SendEmailOTP",
            requestBody,
            { headers: { Authorization: `Bearer ${AuthorizeToken}` } }).then((res) => {
              this.Loading = false;
              if (res.status == '200') {
                if (res.data.processResult.Successed = true) {
                  this.$store.state.Otp.KEY = this.Email;
                  this.$store.state.Otp.ISEMAIL = true;
                  this.$store.state.Otp.REFERENCE = res.data.reference != null ? res.data.reference : null;
                  this.$router.push('/CheckOTP');
                }
                else {
                  Swal.fire({
                    icon: 'error',
                    html: '<lable class="fs-4 fw-normal font-family">เกิดข้อผิดพลาดในการส่ง OTP</lable>',
                    confirmButtonText: 'รับทราบ'
                  });
                  this.ClearData();
                }

              }
              else {
                Swal.fire({
                  icon: 'error',
                  html: '<lable class="fs-4 fw-normal font-family">เกิดข้อผิดพลาดในการส่ง OTP</lable>',
                  confirmButtonText: 'รับทราบ'
                });
                this.ClearData();
              }
            }).catch((error) => {
              this.Loading = false;
              Swal.fire({
                icon: 'error',

                html: `<lable class="fs-4 fw-normal font-family">${error.response.data.ErrorMessage}</lable>`,
                confirmButtonText: 'รับทราบ'
              });

              this.ClearData();
            });
        }
      }
      else {
        this.ClearData();
      }
    },
    ClearData() {
      this.$store.state.EditAgentInfo.CHANGE_EMAIL.EMAIL = '';
      this.$store.state.EditAgentInfo.CHANGE_EMAIL.SUCCESS = false;
      this.Email = '';
    },
    ValidateEmail(val) {
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z.]{2,}$/;
      return emailRegex.test(val);
    }
  },
};
</script>

<style scoped></style>